import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "../auth.service";
import { DataService } from "src/app/service/buildings.service";
import swal from "sweetalert2";
import Hammer from "hammerjs";

@Component({
  selector: "app-authorization",
  templateUrl: "./authorization.component.html",
  styleUrls: ["./authorization.component.scss"]
})
export class AuthorizationComponent implements OnInit {
  signinForm: FormGroup;
  signupForm: FormGroup;
  hide = true;
  clientType: [];

  isUserSigningUp = false;
  fadeOutSignInScreen = false;

  authElement = null;
  hammertime = null;
  authElementPosY: number = 0;

  constructor(
    private auth: AuthService,
    private service: DataService,
    public dialogRef: MatDialogRef<AuthorizationComponent>,
    private formbuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.signinForm = this.formbuilder.group({
      userName: [null, [Validators.required]],
      password: [
        null,
        [Validators.required, Validators.minLength(6), Validators.maxLength(30)]
      ]
    });

    this.signupForm = this.formbuilder.group({
      userName: [null, [Validators.required]],
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      middleName: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      clientTypeId: [null, [Validators.required]],
      password: [
        null,
        [Validators.required, Validators.minLength(6), Validators.maxLength(30)]
      ]
    });

    this.getClientType();
  }

  ngAfterViewInit() {
    this.authElement = document.querySelector(".auth-class");
    this.hammertime = new Hammer(this.authElement);
  }

  onPanMove(ev) {
    let current_pos = this.authElementPosY + ev.deltaY;
    this.authElement.style.transform = "translateY(" + current_pos + "px)";

    if (ev.isFinal) {
      this.authElementPosY = current_pos;
    }
  }

  getClientType() {
    var self = this;

    this.service.getClientType().subscribe({
      next(data) {
        self.clientType = data;
        console.log("clienttype auth:" + JSON.stringify(self.clientType));
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  closeAuthorizationDialog() {
    this.dialogRef.close();
  }

  onUserEnterSigningUp() {
    this.isUserSigningUp = true;
  }

  onUserExitSigningUp() {
    this.fadeOutSignInScreen = true;
    setTimeout(() => {
      this.fadeOutSignInScreen = this.isUserSigningUp = false;
    }, 1000);
  }

  onUserRequestSignIn() {
    const alt = swal.mixin({
      toast: true,
      showConfirmButton: false,
      position: "bottom"
    });

    let t = this;

    console.log("userName" + this.signinForm.value.userName);
    console.log("password" + this.signinForm.value.password);

    console.log(JSON.stringify(this.signinForm.value));

    if (!this.signinForm.valid) {
      alt({
        type: "error",
        title: "Fill all fields",
        timer: 5000
      });
    } else {
      this.auth.signin(this.signinForm.value).subscribe({
        next(data) {
          console.log("data:" + JSON.stringify(data));
          this.dataToken = data;
          this.token = this.dataToken.auth_token;

          console.log("data:" + this.token);
          localStorage.setItem("token", this.token);
          console.log("Token:" + localStorage.getItem("token"));

          alt({
            type: "success",
            title: "Logged in successfuly",
            timer: 5000
          });

          t.dialogRef.close();
        },

        error(msg) {
          alt({
            type: "error",
            title: "Invalid username or password.",
            timer: 5000
          });

          console.log("Error : ", msg);
        }
      });
    }
  }

  onUserRequestSignUp() {
    const alt = swal.mixin({
      toast: true,
      showConfirmButton: false,
      position: "bottom"
    });

    if (!this.signupForm.valid) {
      alt({
        type: "error",
        title: "Fill all fields",
        timer: 5000
      });
    } else {
      let self = this;
      this.auth.signUp(this.signupForm.value).subscribe({
        next(data) {
          console.log("data33:" + data);

          alert(
            "Account created and sent confirmation link to your email address"
          );
          // this.router.navigate(["/buy"]);
        },

        error(msg) {
          self.onUserExitSigningUp();
          console.log("msg.status:" + msg.status);
          if (msg.status == 200) {
            alt({
              type: "success",
              title:
                "Account created and sent confirmation link to your email address",
              timer: 5000
            });
          } else {
            console.log("Error Getting Location: ", msg);

            alt({
              type: "error",
              title: msg.error.duplicateUserName[0],
              timer: 5000
            });
          }
        }
      });
    }
  }
}
